import { render } from "./AlarmStandardSearch.vue?vue&type=template&id=6fb8adea"
import script from "./AlarmStandardSearch.vue?vue&type=script&lang=js"
export * from "./AlarmStandardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__